import { TdsIcon } from '@scania/tegel-react'
import styled from 'styled-components'
import type { AuditDetailPanelWrapperProps } from './audit-detail-panel.interfaces'

const HeaderRow = styled.div`
  flex-wrap: nowrap !important;
  justify-content: space-between;
  align-items: center;
`

export function AuditDetailPanelWrapper({
  children,
  onCloseClick,
  header,
  className
}: AuditDetailPanelWrapperProps): JSX.Element {
  return (
    <div className={className}>
      <HeaderRow className='tds-row'>
        <h4>{header}</h4>
        {onCloseClick && (
          <button
            className='sdds-btn sdds-btn-sm sdds-btn-secondary'
            onClick={onCloseClick}
            title='Close'
          >
            <TdsIcon name='cross' size='20px' />
          </button>
        )}
      </HeaderRow>
      {children}
    </div>
  )
}
